import { SlotGameType1_21 } from '../SlotGameType1_21';

export class AncientSea3D21 extends SlotGameType1_21
{
}
